import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, concatMap, first, filter, take } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AngularFirestore } from '@angular/fire/firestore';
import { VehicleModel } from '../models/vehicle.model';
import { UserService } from '../core/user.service';
import { firestore } from 'firebase';
import { BrandModel } from '../models/brand.model';
import { ModelModel } from '../models/model.model';

@Injectable({
  providedIn: 'root'
})
export class VehiclesService {
  public vehicleBrands: Array<any>;
  public vehicleTypes: Array<any>;
  public vehicleModels: Array<any>;
  public vehicleColors: Array<any>;
  public myVehicles;
  public user: any;

  constructor(
    private http: HttpClient,
    private db: AngularFirestore,
    private userService: UserService
    ) { 
    this.myVehicles    = this.http.get<any>('./assets/data/my-vehicles.json');
    this.userService.user.subscribe(user => this.user=user);
  }

  async loadData(){
    this.vehicleTypes = await this.http.get<any>('./assets/data/vehicles-type.json').toPromise();
    this.vehicleBrands = []
    this.vehicleModels = []
    this.vehicleColors = await this.http.get<any>('./assets/data/vehicle-colors.json').toPromise();

  }  



  //________________________
  /**
    *Refresca las marcas basado en el tipo de vehiculo
   */
  getFilteredBrands(vehicleId: number) {
    // console.log("____filtraje : ", vehicleId);
    return this.db.collection<BrandModel>('brands', ref => ref.where('typeId', '==', vehicleId)) 
    .snapshotChanges()
    .pipe(map( actions => actions.map(a => {
      const data = a.payload.doc.data() as BrandModel;
      const id = a.payload.doc.id;
      return {id,  ...data};    
    }) ))
    // .subscribe( brand => { 
    //   this.vehicleBrands = brand as BrandModel[]
    //   console.log("Marcas : ",this.vehicleBrands);
    // });
  }

  getAllBrands() {
    // console.log("Getting all the brands....");

    return this.db.collection<BrandModel>('brands', ref => ref) 
    .snapshotChanges()
    .pipe(map( actions => actions.map(a => {
      const data = a.payload.doc.data() as BrandModel;
      const id = a.payload.doc.id;
      return {id,  ...data};    
    }) ))
  }

  /**
    *Refresca los modelos basado en el nuevo brandID
   */
  getFilteredModels(brandId: string){
    // console.log("____filtraje : ", brandId);
   return this.db.collection<ModelModel>('models', ref => ref.where('brandId', '==', brandId)) 
    .snapshotChanges()
    .pipe(map( actions => actions.map(a => {
      const data = a.payload.doc.data() as ModelModel;
      const id = a.payload.doc.id;
      return {id,  ...data};    
    }) ))
    // .subscribe( model => { 
    //   this.vehicleModels = model as ModelModel[]
    //   console.log("Modelos : ",this.vehicleModels);
    // });
  }

  //________________________






  getVehicleBrand(brandId){
    return this.vehicleBrands.find(({id}) => id == brandId);
  }
  getVehicleType(typeId){
    return this.vehicleTypes.find(({id}) => id == typeId);
  }

  getMyVehicles(id): Observable<VehicleModel[]>{
    // let userId = this.user ? this.user.id : "UrTW6fIPpbzCksBEKv91";
    // console.log("UserG:", this.userService.userG);
    return this.db.collection<VehicleModel>(
      'vehicles', 
      ref => ref.where('idUser', '==', id)
    )
    .snapshotChanges()
    .pipe(
      map(docs => docs.map(a => {
        const data = a.payload.doc.data() as VehicleModel;
        const id = a.payload.doc.id;
        return {id,  ...data };
      }))
    );         
  }

  async checkPlate(numberPlate):Promise<boolean> {
   return await this.db.collection<VehicleModel>(
      'vehicles', 
      ref => ref.where('numberPlate', '==', numberPlate)
    )
    .valueChanges()
    .pipe(take(1))
    .toPromise()
    .then(data=>{
      return !!data.length;
    });
  }

  deleteVehicle(id){
    return this.db.collection('vehicles').doc(id).delete();
  }

  addVehicle(vehicle){
    vehicle.createdAt = firestore.FieldValue.serverTimestamp();  
    vehicle.updatedAt = firestore.FieldValue.serverTimestamp();    
    this.db.collection('vehicles').add({...vehicle});
  }

  updateVehicle(id, vehicle){  
    vehicle.updatedAt = firestore.FieldValue.serverTimestamp();    
    this.db.collection('vehicles').doc(id).update({...vehicle});
  }
}
